"use client";

import LoadingComp from "./tiktok/loading";
import { usePathname } from "next/navigation";
import { useUserInfo } from "./hooks";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { v4 as uuidv4 } from "uuid";
export default function InitStaeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const publicPaths = ["/", "/zh", "/en", "/zh/login", "/en/login", "/zh/bindPhone", "/en/bindPhone", "/ecAcademy"];
  const dataPaths = ["/tiktok", "/shopify", "/video"];
  const sharePaths = ["/ai/share"];
  const isPublicPage = publicPaths.includes(pathname) || [...dataPaths, ...sharePaths].some(p => pathname.startsWith(p));
  const {
    isLoading,
    user
  } = useUserInfo();
  useEffect(() => {
    const getAnonymousUuid = () => {
      let uuid = localStorage.getItem("anonymousUuid");
      if (!uuid) {
        uuid = uuidv4();
        localStorage.setItem("anonymousUuid", uuid);
      }
      return uuid;
    };
    const anonymousUuid = getAnonymousUuid();
    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        phone: user.phone,
        username: user.username
      });
      Sentry.setTag("user_type", "registered");
      Sentry.setExtra("anonymous_id", anonymousUuid);
    } else {
      Sentry.setUser({
        id: anonymousUuid,
        username: "anonymous_" + anonymousUuid
      });
      Sentry.setTag("user_type", "anonymous");
    }
  }, [user]);
  if (isLoading) {
    if (!isPublicPage) {
      return <LoadingComp />;
    }
    return <>{children}</>;
  } else {
    return <>{children}</>;
  }
}